import { InterestsQuestionsKeys } from "@/lib/strings/profile-data";
import * as React from "react";

interface InterestsContentProps {
  data: InterestsQuestionsKeys[];
}

const interestEmojis: Record<InterestsQuestionsKeys, string> = {
  "Listening to music": "🎵",
  "Making music": "🎼",
  "Movies / TV": "📺",
  Gaming: "🎮",
  "Drawing / art": "🎨",
  Writing: "📝",
  Reading: "📖",
  Photography: "📸",
  Dancing: "💃",
  "Cooking / baking": "🍳",
  Food: "🍽️",
  Fashion: "👗",
  "Playing sports": "🏃",
  "Being in nature": "🌿",
  "Pets / animals": "🐾",
};

export const InterestsContent = React.forwardRef<
  HTMLUListElement,
  InterestsContentProps
>(({ data }, ref) => {
  return (
    <ul ref={ref} className="flex flex-wrap gap-2">
      {data.map((item, index) => (
        <li key={index} className="px-3 py-1 text-sm text-gray-600">
          <span className="mr-1 text-gray-600">
            {interestEmojis[item] || "•"}
          </span>
          {item}
        </li>
      ))}
    </ul>
  );
});

InterestsContent.displayName = "InterestsContent";
